import * as React from 'react';
import PropTypes from "prop-types"
import M from 'materialize-css';
import './getIntouch.scss';

import isBrowser from '../isBrowser';

const GetInTouchForm = ({ children, id }) => {

  React.useEffect(()=>{
    if( isBrowser() ){
      var elemId = ".modal#"+id
      var elem = document.querySelector(elemId);
      M.Modal.init(elem, {
        preventScrolling:true
      });
    }
  }, [id])

  const ceotalk = (
    
      <div className="content">
      <span className="quote"><i className="fas fa-quote-left"></i></span>
      <p>
        MrPentester helped us when our website was under continuos attack and we were demanded ransom as payment, but MrPentester team took
        the challenge and restored our services within 3 hours and eliminated all loopholes within a day. Highly recommended. 
      </p>
      <div className="profile">
        <div className="image">
          <img src="https://cdn4.iconfinder.com/data/icons/small-n-flat/24/user-alt-512.png" alt="name"/>
        </div>
        <div className="name">
          <h4>Confidential </h4>
          <small>Co-Founder, Finance Domain</small>
        </div>
      </div>
    </div>
    )

  return (
    <>
      <div className="modal getintouch" id={id}>
        <div className="modal-content">
          <div className="row content-row">
            <div className="col m4 s12 ceo-talk desktop-div">
              { ceotalk }
            </div>
            <div className="col m8 s12 get-in-touch-form">
              <div className="content">
                <h3 className="title">Get in touch with us</h3>
                <p>contact@mrpentester.com</p>
                <p>+ (91) 96114 78322</p>
                <div className="form">
                  { children }
                </div>
              </div>
            </div>
            <div className="col m4 s12 ceo-talk mobile-div">
              { ceotalk }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}



GetInTouchForm.propTypes = {
  children: PropTypes.node.isRequired,
}

export default GetInTouchForm;
